import { render, staticRenderFns } from "./VehicleInfoComponent.vue?vue&type=template&id=e0ba6698&scoped=true&"
import script from "./VehicleInfoComponent.vue?vue&type=script&lang=js&"
export * from "./VehicleInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInfoComponent.vue?vue&type=style&index=0&id=e0ba6698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ba6698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
